import { Subscription } from './../../_models/subscription';
import { ActivatedRoute } from '@angular/router';
import { StudentService } from './../../_services/student.service';
import { AuthService } from './../../_services/auth.service';
import { Component, Input, OnInit } from '@angular/core';
import { Student } from 'src/app/_models/student';

@Component({
  selector: 'app-study-material-student',
  templateUrl: './study-material-student.component.html',
  styleUrls: ['./study-material-student.component.css']
})
export class StudyMaterialStudentComponent implements OnInit {
  @Input() server_user_id=0
  quizarea_syllabus = { topics: [], selectedTopics: [] }
  subscription = new Subscription()
  student = new Student()
  loading=false
  
  constructor(
    public authService: AuthService,
    private studentService: StudentService
  ) { }

  ngOnInit(): void {
    this.loading=true
    
     if(this.server_user_id!=0){
       this.studentService.getByUserId(this.server_user_id).subscribe(
        data=>{
          this.initStudent(data)
        }
       )
     }
    
  }

  initStudent(data:Student){

    if(data!=null){
       this.student= data
       if(this.student['subscription_object']!=null){
        this.subscription=this.student['subscription_object']
        this.quizarea_syllabus = this.student['syllabus']
       }
       this.loading=false
    }
  }
  
}
